import { shallowRef, type ShallowRef } from "vue";

export type SportsResultsSaveFn = () => Promise<void>;

export const sportsResultsSaveRef: ShallowRef<SportsResultsSaveFn | null> = shallowRef(null);
